import React, { useState } from "react";
import { AppBar, IconButton, Box, Container } from "@mui/material";
// import logo from "../../../assets/images/logo.png";
import logo from "../../../assets/images/techifywhite.svg";
import mobile_menu from "../../../assets/images/mobile_menu.png";
import notification from "../../../assets/images/notification.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LinkData from "./Lisks.json";
import MobileMenu from "./MobileMenu";
import NotificationsSlide from "../../admin/auth/NotificationsSlide";
import { useSelector, useDispatch } from "react-redux";
import {
  clearAuthStorage,
  setRedirTo,
} from "../../../redux/slice/user/UserSlice";
// import { LOGOUT } from "../../../constants/apiEndPoints";
// import httpRequest from "../../../axios/index";
// import { toast } from "react-hot-toast";

import {
  LogoImage,
  Toolbarstyles,
  SigninButton,
  SignUpButton,
  DeskTopLink,
  LogoMain,
  AuthButtonMain,
  ToolbarMain,
  NotificationBTn,
} from "./HeaderStyle";
import { signouthandler } from "../../../services/auth/logout";
import SmallLoader from "../loader/SmallLoader";

const Header = () => {
  const [loading, setLoading] = useState(false);
  const Userinfo = useSelector((state) => state?.auth);

  const isAuth = Userinfo?.isAuthenticated;
  const ShowNotification =
    Userinfo?.user?.status === "active" && Userinfo?.user?.review_approved;

  const IsUser = Userinfo?.user?.role === "user";

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showDrawer, setshowDrawer] = useState(false);

  const NotShowDesktop = [
    // "/",
    "/login",
    "/signup",
    "/forgot-password",
    "/verification-code",
    "/customer-type",
    "/business-customer",
    "/business-customer",
    "/business-customer",
    "/payment-method",
    "/payment-account",
    "/card-infor",
    "/change-password",
    "/verification",
    "/pending-appproval",
    "/password-success",
  ];

  const ShowMenu = NotShowDesktop.includes(location.pathname);

  const handleCloseNavMenu = () => {
    setIsDrawerOpen(false);
    document.body.classList.remove("drawer-open");
  };
  const handleOpenNavMenu = () => {
    setIsDrawerOpen(true);
    document.body.classList.add("drawer-open");
  };

  const Logouthandler = async () => {
    setLoading(true);

    try {
      const res = await signouthandler();
      if (res && res.status === 200) {
        // navigate("/login");
        dispatch(setRedirTo(""));
        dispatch(clearAuthStorage());
      }
    } catch (error) {
      console.error("Logout Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          paddingTop: "9px",
          paddingBottom: "3px",
          boxShadow: "none",
        }}
      >
        <Container maxWidth="lg">
          <ToolbarMain sx={Toolbarstyles.root}>
            <LogoMain>
              <Link to="/">
                <LogoImage src={logo} alt="logoimg" />
              </Link>
            </LogoMain>

            {!ShowMenu && isAuth && IsUser && (
              <DeskTopLink
                sx={{ display: { xs: "none", md: "none", lg: "flex" } }}
              >
                {LinkData.homeLink.map((value) => {
                  const IsProfilePages = ["/profile"];
                  const IsMyOrderPages = [
                    "/my-orders",
                    "/order-details",
                    "/order-label",
                  ];

                  const TransactionPage = ["/transaction"];

                  const isActiveLink =
                    location.pathname === value.url ||
                    (IsProfilePages.includes(location.pathname) &&
                      value.title === "Profile") ||
                    (IsMyOrderPages.includes(location.pathname) &&
                      value.title === "My Orders") ||
                    (TransactionPage.includes(location.pathname) &&
                      value.title === "My Transactions") ||
                    (value.title === "Home" &&
                      (location.pathname === "/delivery-home" ||
                        location.pathname === "/delivery-type" ||
                        location.pathname === "/delivery-steps" ||
                        location.pathname === "/route-steps"));

                  return (
                    <>
                      <Link
                        to={value.url}
                        key={value.url + "__" + value.title}
                        className={isActiveLink ? "active_link" : ""}
                      >
                        {value.title}
                      </Link>
                    </>
                  );
                })}
              </DeskTopLink>
            )}
            {location.pathname === "/profile-approved" && (
              <DeskTopLink
                sx={{ display: { xs: "none", md: "none", lg: "flex" } }}
              >
                {LinkData.homeLink.map((value) => {
                  return (
                    <>
                      <span key={value.url + "__" + value.title}>
                        {value.title}
                      </span>
                    </>
                  );
                })}
              </DeskTopLink>
            )}

            <AuthButtonMain>
              {!isAuth ? (
                <>
                  <SigninButton
                    variant="contained"
                    onClick={() => navigate("/login")}
                    disableRipple
                  >
                    Sign in
                  </SigninButton>
                  <SignUpButton
                    variant="contained"
                    onClick={() => navigate("/signup")}
                  >
                    Sign up
                  </SignUpButton>
                </>
              ) : (
                <>
                  <SignUpButton
                    variant="contained"
                    onClick={Logouthandler}
                    disabled={loading}
                  >
                    {loading ? <SmallLoader smallSize={true} /> : "Sign out"}
                  </SignUpButton>
                  {ShowNotification && (
                    <NotificationBTn
                      variant="contained"
                      color="primary"
                      startIcon={<img src={notification} alt="notification" />}
                      disableRipple
                      onClick={() => setshowDrawer(!showDrawer)}
                    />
                  )}
                </>
              )}
              {!ShowMenu && (
                <Box sx={{ display: { xs: "flex", md: "flex", lg: "none" } }}>
                  {IsUser && (
                    <>
                      <IconButton
                        size="small"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        color="inherit"
                      >
                        <img src={mobile_menu} alt="mobile_menu" />
                      </IconButton>
                      <MobileMenu
                        isDrawerOpen={isDrawerOpen}
                        handleCloseNavMenu={handleCloseNavMenu}
                      />
                    </>
                  )}
                </Box>
              )}
            </AuthButtonMain>
          </ToolbarMain>
        </Container>
      </AppBar>
      <NotificationsSlide
        showDrawer={showDrawer}
        setshowDrawer={setshowDrawer}
      />
    </>
  );
};

export default Header;
